import React from 'react'
import { buildForwardingComponent } from '../utils/buildComponent'
import TableCell, {
  TableCellProps as MuiTableCellProps,
} from '@mui/material/TableCell'
import { styled } from '@mui/material/styles'

const StyledTableCell = styled(TableCell)(
  ({ noWrap }: { noWrap: boolean }) => ({
    whiteSpace: noWrap ? 'nowrap' : 'normal',
  })
)

export interface TableRowCellProps extends MuiTableCellProps {
  children: React.ReactNode
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
  noWrap?: boolean
}

const TableRowCell = React.forwardRef<HTMLDivElement, TableRowCellProps>(
  (props: TableRowCellProps, ref: React.Ref<HTMLDivElement>) => {
    const { children, onClick, noWrap = false, ...rest } = props

    return (
      <StyledTableCell noWrap={noWrap} ref={ref} onClick={onClick} {...rest}>
        {children}
      </StyledTableCell>
    )
  }
)

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  TableRowCell.displayName = 'TableRowCell'
}

export default buildForwardingComponent(TableRowCell)
